<div class="wrapper">
	<div class="hint">
		<mat-icon fontIcon="fa-repeat" fontSet="fad" />
		{{ T.SESSION_CREATION_DIALOG_RUNS_AND_INTERMISSIONS | translate }}
	</div>

	<sim-new-list-item
		class="createRun"
		[primaryLabel]="T.AUTOMATIC_RECORDING_SESSION_DIALOG_NEW_RUN"
		[secondaryLabel]="T.AUTOMATIC_RECORDING_SESSION_DIALOG_NEW_RUN_HINT"
		[buttonLabel]="T.AUTOMATIC_RECORDING_SESSION_DIALOG_ADD_RUN"
		(add)="store.scheduleEntryAdded()"
		[disabled]="store.isAutosaving()"
	/>

	<table>
		<th>
			<div>{{ T.LABEL_RUNS | translate }}</div>
			<div>{{ T.LABEL_TIME | translate }}</div>
			<div>{{ T.LABEL_DURATION | translate }}</div>
			<div>{{ T.LABEL_INTERMISSION | translate }}</div>
			<div class="action"><!-- ACTIONS --></div>
		</th>
		@for (scheduleEntryForm of store.scheduleForm.controls; track $index) {
			<sim-schedule-entry [form]="scheduleEntryForm" [hasIntermission]="!$last" [index]="$index" [disabled]="store.isAutosaving()" />
		}
	</table>
</div>
